import { TFunction } from 'i18next'

const TIME_UNITS = [
  { unit: 'years', seconds: 31536000 },
  { unit: 'months', seconds: 2592000 },
  { unit: 'days', seconds: 86400 },
  { unit: 'hours', seconds: 3600 },
  { unit: 'minutes', seconds: 60 },
]

export function timeAgo(date: Date, t: TFunction): string {
  const now = new Date()
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  for (const { unit, seconds: unitSeconds } of TIME_UNITS) {
    const interval = Math.floor(seconds / unitSeconds)
    if (interval >= 1) {
      return t(`promotedFlights.timeAgo.${unit}`, { count: interval })
    }
  }

  return t('promotedFlights.timeAgo.justNow')
}
